import { asArray, asObject, asString } from '@restless/sanitizers';
export var asScoreWithProof = asObject({
    account: asString,
    protocol: asString,
    score: asString,
    merkleProof: asArray(asString),
});
//# sourceMappingURL=scoreWithProof.js.map